<div id="program-selection-menu" class="mdc-menu-surface--anchor" *ngIf="canSeeMenu">
  <div class="program-menu-btn" (click)="toggleMenu()">
   <div *ngIf="programMenu">
     <div class="program-wrapper">
       <span>{{programMenu?.programName ? programMenu?.programName : programMenu?.programUid}} </span>
       <span>({{programMenu?.programUid | slice:-6  }})</span>
    </div>
     <div class="business-wrapper" *ngIf="programMenu?.programUid !== null">
       <span>
         <i [class]="programMenu?.companyUid === currentNativeBn9 ? 'fas fa-onboarding-documentation' : 'fas fa-building'" ></i>
        {{programMenu?.companyName ? programMenu?.companyName : programMenu.companyUid}}</span>
       <span>{{' (' + programMenu?.companyUid + ')'}}</span>
     </div>
   </div>
    <div *ngIf="menuOpen" class="expicon glyphicon glyphicon-chevron-up menu-down">
    </div>
    <div *ngIf="!menuOpen" class="expicon glyphicon glyphicon-chevron-down menu-down">
    </div>
  </div>

  <div #menu class="carm-menu-dropdown mdc-menu-surface" id="program-menu">
    <div class="mdc-list-group" *ngIf="programMenu">

<!--      <div class="mdc-list-sub-heading">-->
<!--        <span class="mdc-list-group__subheader"><span matTooltip="{{programMenu.companyName}} {{' (' + programMenu.companyUid + ')'}}">{{programMenu.companyName}}</span> <span>({{programMenu.companyUid}})</span></span>-->
<!--      </div>-->
      <ul class="mdc-list" role="menu" aria-hidden="true" aria-orientation="vertical" tabindex="-1">
        <li>
          <div class="mdc-list-sub-footing mdc-list-item" (click)="openBusinessSelector()">
            <a [carmRouterLink]="[]" class="mdc-list-end-selector">{{ 'business_selector.showSelector' | translate }}</a>
            <i class="material-icons" aria-hidden="true">keyboard_arrow_right</i>
          </div>
          <ul class="mdc-menu__selection-group">
            <li *ngFor="let program of programMenu.programs" class="mdc-list-item"
              (click)="onProgramSelect(program.programUid)" role="menuitem" tabindex="0">
              <span class="carm-menu-selection-group-icon" *ngIf="program.programUid === programMenu.programUid" >
                <i class="material-icons" aria-hidden="true">keyboard_arrow_right</i>
              </span>
              <span class="mdc-list-item__text inline-center">
                <i *ngIf="program.inactive" class="material-icons text-warning inactive-program-icon" aria-hidden="true">block</i>
                <span *ngIf="program.programName !== null">{{program.programName}}</span>
                <span *ngIf="program.programName !== null">{{ ' (' + program.rmNumber + ')'}}</span>
                <span *ngIf="program.programName === null">{{program.programUid}}</span>            
              </span>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</div>
